import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getIsGiftInfoLoaded } from '../modules/RecipientModule/store/data/data.selectors';
import { getIsFulfilled } from '../store/users/users.selectors';

import useGlobalSettings from './useGlobalSettings';
import useTrackRecipient from './useTrackRecipient';

export default eventName => {
  const { isSegmentInit } = useGlobalSettings();
  const trackEvent = useTrackRecipient();

  const isGiftInfoLoaded = useSelector(getIsGiftInfoLoaded);
  const isUsersLoaded = useSelector(getIsFulfilled);
  const canTrackPageEvent = isGiftInfoLoaded && isUsersLoaded && isSegmentInit;

  useEffect(() => {
    if (canTrackPageEvent) {
      trackEvent(eventName);
    }
  }, [canTrackPageEvent, trackEvent, eventName]);
};
